export const jobArchitectureCardDefaultHeight = '74px';
